import React from 'react';

export default function DonutStat({ label, value, total }) {
  const v = Math.max(0, Number(value) || 0);
  const t = Math.max(0, Number(total) || 0);
  const pct = t > 0 ? Math.min(100, Math.max(0, (v / t) * 100)) : 0;

  const size = 64;
  const stroke = 8;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;

  return (
    <div className="tp-card tp-card--tight" style={{ padding: 12, minWidth: 220 }}>
      <div className="tp-row" style={{ justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 12, color: 'var(--tp-muted)' }}>{label}</div>
          <div style={{ fontSize: 16, fontWeight: 800, marginTop: 4 }}>
            {v} / {t}
          </div>
        </div>

        <div style={{ position: 'relative', width: size, height: size, flex: '0 0 auto' }}>
          <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke="var(--tp-border)"
              strokeWidth={stroke}
              opacity={0.7}
            />
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke="var(--tp-accent)"
              strokeWidth={stroke}
              strokeLinecap="round"
              strokeDasharray={`${dash} ${c - dash}`}
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
            />
          </svg>
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'grid',
              placeItems: 'center',
              fontSize: 12,
              fontWeight: 800,
            }}
          >
            {Math.round(pct)}%
          </div>
        </div>
      </div>
    </div>
  );
}
